import { CUSTOM_ELEMENTS_SCHEMA, Injectable, ModuleWithProviders, NgModule, Pipe, PipeTransform } from "@angular/core";
import { TranslateLoader, TranslateModule, TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Observable, of } from "rxjs";

const translations: { [key: string]: string } = {};

class FakeLoader implements TranslateLoader {
  public getTranslation(): Observable<{ [key: string]: string }> {
    return of(translations);
  }
}

@Pipe({
  name: "translate",
  standalone: false
})
export class TranslatePipeMock implements PipeTransform {
  public name: string = "translate";

  public transform(query: string) {
    return query;
  }
}

@Injectable()
export class TranslateServiceStub {
  public get<T>(key: T): Observable<T> {
    return of(key);
  }

  public use<T>(key: T): Observable<T> {
    return of(key);
  }
}

@NgModule({
  declarations: [TranslatePipeMock],
  providers: [
    { provide: TranslateService, useClass: TranslateServiceStub },
    { provide: TranslatePipe, useClass: TranslatePipeMock }
  ],
  imports: [
    TranslateModule.forRoot({
      loader: { provide: TranslateLoader, useClass: FakeLoader }
    })
  ],
  exports: [TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TranslateTestingModule {
  public static forRoot(): ModuleWithProviders<TranslateTestingModule> {
    return {
      ngModule: TranslateTestingModule,
      providers: [TranslateService, TranslatePipe]
    };
  }
}
